import { useContext } from "react";
import RegistrationContext from "../../contexts/RegistrationContext";

function NextButton() {
  const { cart } = useContext(RegistrationContext);
  const total = cart?.total_price;

  return (
    <div className="w-full flex justify-between items-center mt-4 px-4 py-3 rounded-lg bg-[#EBFCFC] border border-[#98e1ff]">
      {total != null ? (
        <div className="text-sm text-[#404040]">
          <span className="font-semibold text-[#002E78]">Registration total: </span>
          <span className="text-lg font-bold text-[#002E78]">{total} €</span>
        </div>
      ) : (
        <div />
      )}
      <button className="button" type="submit">
        Next
      </button>
    </div>
  );
}

export default NextButton;
